import { useEffect, useRef } from "react";
import "./TestHeroBanner.css";

const MA_APPLY_URL = "https://admissions.eusbd.eu/esbd-apply/MA-GBSL/";

const panels = [
  { label: ["Speak With", "Admissions"], href: "/admissions", bg: "th-pbg1", img: "/homepgImages/hero1.jpeg" },
  { label: ["Book a Virtual", "Consultation"], href: MA_APPLY_URL, bg: "th-pbg2", img: "/homepgImages/hero2.jpeg" },
  { label: ["Visit Our", "Malta Campus"], href: "#", bg: "th-pbg3", img: "/homepgImages/hero3.jpeg" },
];

export default function TestHeroBanner() {
  const particlesRef = useRef(null);

  useEffect(() => {
    const container = particlesRef.current;
    if (!container) return;
    const types = ["", "--line", "--diamond"];
    for (let i = 0; i < 40; i++) {
      const p = document.createElement("div");
      const t = types[Math.floor(Math.random() * 3)];
      p.className = "th-particle th-particle" + t;
      const s = Math.random() * 6 + 3;
      p.style.cssText =
        "left:" + Math.random() * 100 + "%;width:" + s + "px;height:" + s +
        "px;background:rgba(197,164,78," + (Math.random() * 0.25 + 0.08) +
        ");animation-duration:" + (Math.random() * 10 + 6) +
        "s;animation-delay:" + Math.random() * 8 + "s";
      container.appendChild(p);
    }
  }, []);

  return (
    <section className="th-hero">
      <div className="th-hero__gs" />
      <div className="th-hero__particles" ref={particlesRef} />
      <div className="th-hero__orbs">
        <div className="th-hero__orb th-hero__orb--1" />
        <div className="th-hero__orb th-hero__orb--2" />
        <div className="th-hero__orb th-hero__orb--3" />
      </div>
      <div className="th-hero__beam" />
      <div className="th-hero__shimmer">
        <div style={{ width: 280, height: 280, top: "10%", left: "5%", animationDelay: "0s" }} />
        <div style={{ width: 180, height: 180, top: "50%", left: "30%", animationDelay: "-2s" }} />
        <div style={{ width: 350, height: 350, top: "-10%", left: "20%", animationDelay: "-3.5s" }} />
        <div style={{ width: 120, height: 120, top: "70%", left: "8%", animationDelay: "-1.5s" }} />
      </div>

      <div className="th-hero__content">
        <div className="th-hero__accent" />
        <h1 className="th-hero__title">
          Your Future in Business,<br />
          <em>Leadership</em> and<br />
          <em>Diplomacy</em> Starts Here
        </h1>
        <p className="th-hero__desc">
          A Malta-based higher education institution preparing future leaders
          through flexible, internationally focused programmes in business,
          leadership and diplomacy.
        </p>
        <div className="th-hero__btns">
          <a href={MA_APPLY_URL} target="_blank" rel="noreferrer" className="th-hero__btn">
            Apply Now
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 12L12 4M12 4H6M12 4v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </a>
          <a href="/admissions" className="th-hero__btn th-hero__btn--ghost">Explore Programmes</a>
        </div>
      </div>

      <div className="th-hero__panels">
        {panels.map((p, i) => (
          <a key={i} href={p.href} className="th-hero__panel">
            <div className="th-hero__panel-in">
              <div
                className={`th-hero__panel-bg ${p.bg}`}
                style={{ backgroundImage: `url(${p.img})` }}
              />
              <div className="th-hero__panel-ov" />
            </div>
            <div className="th-hero__panel-lbl">
              <span>{p.label[0]}<br />{p.label[1]}</span>
              <div className="th-hero__panel-line" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
